var map = {
	"./AMERICAS_Mexico_Tuxpan_Aerial_Tanks_2021-06_1920x550.jpg": "94d8",
	"./Oficina Argentina_BsAs.jpeg": "2b50",
	"./Oficina Brasil_RJ.jpeg": "d83a",
	"./Oficina Mexico.jpeg": "eba8",
	"./Oficina Peru.jpeg": "e032",
	"./Oiltanking_South-America_Argentina_Brandsen_Building-Outside_2010-01-15_014.jpg": "8d4c",
	"./Oiltanking_South-America_Argentina_Puerto-Rosales_Building-Outside_2012-01-24_6584.jpg": "4e35",
	"./Oiltanking_South-America_Brazil_Vitoria_Truckloading_2012-06-29_0942.jpg": "a69d",
	"./Oiltanking_South-America_Colombia_Cartagena_Terminal-Aerial_2011-06-10.jpg": "e450",
	"./Oiltanking_South-America_Peru_Callao_Tank_2010-01-26_1120391.jpg": "4cdb",
	"./Oiltanking_South-America_Peru_Chimbote_Tank_2016-10-13_1.jpg": "3600",
	"./Oiltanking_South-America_Port-Acu.jpg": "9b5a",
	"./Terminal Page Puerto Bahia.jpg": "3a76",
	"./image_ot-panama-coassa-colon_tanks1_1920px.jpg": "3639",
	"./image_ot-peru-andina-services_marine-platform1_1920px.jpg": "c6cd8",
	"./image_ot-peru-eten_tanks_1920px.jpg": "47c3",
	"./image_ot-peru-matarani_tanks1_1920px.jpg": "77f9",
	"./image_ot-peru-salaverry_tanks2_1920px.jpg": "8145",
	"./image_ot-peru-supe_tanks_1920px.jpg": "e0af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c001";